// import antdEnUS from 'ant-design-vue/es/locale-provider/en_US'
// import momentEU from 'moment/locale/eu'
import global from './en-US/global'
import menu from './en-US/menu'
import pamm from './en-US/pamm'
import activities from '@/views/(public)/activities/_locale/en-US'
import tradeCommission from './en-US/tradeCommission'
import flowCommission from './en-US/flowCommission'
import fundDetails from '@/views/(public)/fund-details/_locale/en-US'
import transactionReports from '@/views/(public)/transaction-reports/_locale/en-US'
import promotionCampaign from './en-US/promotionCampaign'
import invitationManagement from '@/views/introducing-broker/invitation-management/_locale/en-US'
import ibMenu from '@/views/introducing-broker/_locale/en-US/menu'
import ibRoute from '@/views/introducing-broker/_locale/en-US/route'
import contractManagement from '@/views/(public)/contract-management/locale/en-US'
import login from './en-US/login'
import account from '@/views/(public)/account/_locale/en-US'
import deposit from '@/views/(public)/deposit/_locale/en-US'
import withdraw from '@/views/(public)/withdraw/_locale/en-US'
import components from './en-US/components'
import common from './en-US/common'
import trading from '@/views/(public)/trading/_locale/en-US'
import user from '@/views/user/_locale/en-US'
import ib from '@/views/introducing-broker/_locale/en-US'
import files from '@/views/(public)/files/_locale/en-US'
import transfer from '@/views/(public)/transfer/_locale/en-US'
import settings from '@/views/(public)/settings/_locale/en-US'
import modals from '@/modals/locale/en-US'
import customer from '@/views/(public)/customer/_locale/en-US'
import download from '@/views/(public)/download/_locale/en-US'
import course from '@/views/(public)/course/_locale/en-US'
import dashboardView from '@/views/(public)/dashboard/_locale/en-US'
import notifications from '@/views/(public)/notifications/_locale/en-US'
import share from '@/views/(public)/share/_locale/en-US'
import workOrders from '@/views/(public)/work-orders/_locale/en-US'
import pammSignal from '@/views/(public)/pamm/pamm-signal/_locale/en-US'
import pammAssets from '@/views/(public)/pamm/pamm-assets/_locale/en-US'
import copyTrading from '@/views/(public)/copy-trading/_locale/en-US'
import pammOrders from '@/views/(public)/pamm/pamm-orders/_locale/en-US'
import pammStrategys from '@/views/(public)/pamm/pamm-strategys/_locale/en-US'
import pammComponents from '@/views/(public)/pamm/_locale/en-US'

export default {
  followOrder: 'followOrder',
  innerTransfer: 'inner Transfer',
  outerTransfer: 'outer Transfer',
  walletAccount: 'wallet Account',
  mt4Account: 'mt4 Account',
  setFullAmount: 'set Full Amount',
  view: 'view',
  download: 'Download',
  yes: 'Yes',
  no: 'No',
  confirm: 'Confirm',
  cancel: 'Cancel',
  placeholder: {
    'not-set': 'Not set',
  },
  ...global,
  ...menu,
  share,
  ...ibMenu,
  ...ibRoute,
  ...tradeCommission,
  ...flowCommission,
  ...promotionCampaign,
  ...invitationManagement,
  ...account,
  ...download,
  contractManagement,
  transfer,
  withdraw,
  trading,
  account,
  pamm,
  settings,
  components,
  common,
  activities,
  fundDetails,
  'transaction-reports': transactionReports,
  user,
  ib,
  files,
  deposit,
  modals,
  customer,
  course,
  dashboard: dashboardView,
  notifications,
  workOrders,
  pammSignal,
  pammAssets,
  pammOrders,
  pammStrategys,
  pammComponents,
  login,
  copyTrading,
}
